(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_rapidsearch-translator"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() { 
        var href = window.location.href;
        if (href.indexOf("/collections/") === -1) return;

        var filterClickedStatus = "off";
        var clickElement = null;
        var lang = window.rapidsearchTranslations ? window.rapidsearchTranslations.lang : $('html').attr('lang').substring(0,2);
        var headerDict = window.rapidsearchTranslations ? window.rapidsearchTranslations.headers : {};
        var checkboxDict = window.rapidsearchTranslations ? window.rapidsearchTranslations.checkboxes : {};

        function clickFilters(filter) {
            clickElement = false;
            switch(filter.currentTarget.className) {
                case "rps-filter-checkbox-label":
                case "rps-filter-label-container":
                case "rps-filter-checkbox":
                    clickElement = filter.srcElement.parentElement.parentElement.children[0];
                    break;
                case "rps-checked":
                    clickElement = filter.srcElement;
                    break;
                case "rps-reset-button rps-vertical-selected-filter-remove":
                    var count = $('.rps-vertical-selected-filters-container .rps-vertical-selected-filter-container').length;
                    if (count < 2) {
                        translateFiltersDelayed(".rps-result-page-wrapper");
                    } else {
                        clickElement = $('.rps-checked svg').parent()[0];
                    }
                    break;
                case "rps-reset-button rps-vertical-selected-filters-clear":
                case "rps-mobile-filter-clear-button":
                    translateFiltersDelayed(".rps-result-page-wrapper");
                    break;
                case "rps-reset-button":
                    clickElement = $('.rps-checked svg').parent()[0];
                    break;
                default:
                    clickElement = filter.srcElement;
            }
            if (clickElement) {
                filterClickedStatus = clickElement.childElementCount === 1 ? "on" : "off";
                if (filterClickedStatus === "on") {
                    translateFiltersDelayed(".rps-result-page-wrapper");
                } else {
                    addClickEventListenersDelayed("rps-reset-button");
                }
            }
        }
        // Universal normalize function
        function normalizeKey(text) {
            return text
                .replace(/:\s*$/, '')  // Remove trailing ":"
                .replace(/\s+/g, '_')  // Spaces → underscores
                .trim();
        }

        var clickOpenFilters = function () {
            translateFilters(".rps-mobile-filter-body-container");
        };
        var clickOpenFilterBlock = function (block) {
            translateFiltersDelayed(".rps-result-page-wrapper");
        };

        var translateFilters = function (waitElement) {
            waitForElementToDisplay(waitElement, function() {
                if($("body").hasClass("rps-has-filters")) {
                    // Filter title translations using dynamic dict
                    var text = "", translation = "";
                    $(".rps-filter-block-header").each(function() {
                        text = normalizeKey($(this).find("p").text());
                        translation = headerDict[text] || text;  // Handle trailing :
                        $(this).find("p").text(translation);
                    });

                    // Checkbox & selected filter translations
                    $(".rps-vertical-selected-filter-container").each(function() {
                        text = $(this).find("strong").text();
                        translation = checkboxDict[text] || text;
                        $(this).find("strong").text(translation);
                    });

                    $('.rps-vertical-selected-filter').each(function () {
                        var node = this.firstChild;
                        if (!node || node.nodeType !== 3) return;
                        text = node.nodeValue.replace(/\u00A0/g, ' ').trim().replace(/:\s*$/, '');
                        translation = headerDict[text];
                        if (translation) {
                            var trailingSpace = node.nodeValue.match(/[\s\u00A0]*$/);
                            node.nodeValue = translation + ': ' + (trailingSpace ? trailingSpace[0] : '\u00A0');
                        }
                    });

                    $(".rps-filter-checkbox-label").each(function() {
                        text = $(this).text();
                        translation = checkboxDict[text] || text;
                        $(this).text(translation);
                    });

                    // Add event listeners (unchanged)
                    ['rps-filter-checkbox', 'rps-filter-label-container', 'rps-mobile-filter-clear-button', 'rps-mobile-filters-open-button', 'rps-filter-block-container'].forEach(function(cls) {
                        var collection = document.getElementsByClassName(cls);
                        for (var key in collection) {
                            if (collection.hasOwnProperty(key)) {
                                if (cls === 'rps-mobile-filters-open-button') {
                                    collection[key].addEventListener("click", clickOpenFilters, false);
                                } else if (cls === 'rps-filter-block-container') {
                                    collection[key].addEventListener("click", clickOpenFilterBlock, false);
                                } else {
                                    collection[key].addEventListener("click", clickFilters, false);
                                }
                            }
                        }
                    });

                    $('.rps-price-filter-input').on('blur', function () {
                        addClickEventListenersDelayed("rps-reset-button");
                    });
                    $('.rps-price-filter-slider input').on('mouseup', function () {
                        addClickEventListenersDelayed("rps-reset-button");
                    });
                }
            }, 1000, 9000);
        };
        translateFilters(".rps-filter-menu-desktop-container");

        // Scroll events (unchanged from your script)
        // ... (all your #Slide-template--... scroll handlers here, unchanged)

        async function translateFiltersDelayed(waitElement) {
            await new Promise(resolve => setTimeout(resolve, 2000));
            translateFilters(waitElement);
        }
        async function addClickEventListenersDelayed(elementClass) {
            await new Promise(resolve => setTimeout(resolve, 2500));
            var collection = document.getElementsByClassName(elementClass);
            for (var key in collection) {
                if (collection.hasOwnProperty(key)) {
                    collection[key].addEventListener("click", clickFilters, false);
                }
            }
        }
    });

    function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
        var startTimeInMs = Date.now();
        (function loopSearch() {
            if (document.querySelector(selector) != null) {
                callback();
                return;
            }
            setTimeout(function () {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) return;
                loopSearch();
            }, checkFrequencyInMs);
        })();
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_video-embed-home-page"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('home-video');
    const badge = video.parentElement.querySelector('.hero-video-promo__price-badge');
    
    video.addEventListener('play', function() {
      badge.classList.add('badge-hidden');
    });
    
    video.addEventListener('pause', function() {
      badge.classList.remove('badge-hidden');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
